export const typography = {
    h900: "font-size: 56px; line-height: 72px; font-weight: 600;",
    h800: "font-size: 46px; line-height: 56px; font-weight: 600;",
    h700: "font-size: 36px; line-height: 54px; font-weight: 600;",
    h600: "font-size: 32px; line-height: 48px; font-weight: 600;",
    h600: "font-size: 24px; line-height: 36px; font-weight: 600;",
    h400: "font-size: 20px; line-height: 32px; font-weight: 600;",
    heading: "font-size: 16px; line-height: 24px; font-weight: 600;",
    bodyL: "font-size: 18px; line-height: 28px; font-weight: 300;",
    bodyM: "font-size: 16px; line-height: 24px; font-weight: 400;",
    bodyS: "font-size: 14px; line-height: 22px; font-weight: 400;",
    menuPosition: "font-size: 16px; line-height: 24px; font-weight: 300;",
    button: "font-size: 16px; line-height: 24px; font-weight: 600;",
    buttonS: "font-size: 14px; line-height: 22px; font-weight: 600;",
    buttonXS: "font-size: 12px; line-height: 20px; font-weight: 600;",
    point: "font-size: 16px; line-height: 24px; font-weight: 400;",
  }
  